import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { useContent } from '../../lib/content';
import { pickLocale } from '../../lib/api';

export default function FAQ() {
  const { content, locale } = useContent();
  const data = content.faq || {};
  const items = data.items || [];
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section bg-bg-secondary border-y border-line"
    >
      <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <p className="text-eyebrow mb-4">{pickLocale(data.eyebrow, locale)}</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]" data-testid="faq-title">
            {pickLocale(data.title, locale)}
          </h2>
        </div>

        <div className="md:col-span-8" data-testid="faq-accordion">
          <div className="border-t border-line">
            {items.map((it, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b border-line" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
                    data-testid={`faq-toggle-${i}`}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                  >
                    <span className="font-mono text-sm md:text-base uppercase tracking-[0.08em] text-ink group-hover:text-acid transition-colors">
                      {pickLocale(it.question, locale)}
                    </span>
                    <span className="flex-shrink-0 w-8 h-8 rounded-full border border-line-strong flex items-center justify-center text-ink group-hover:border-acid group-hover:text-acid transition-colors">
                      {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.2, 0.8, 0.2, 1] }}
                        className="overflow-hidden"
                      >
                        <div className="pb-7 pr-12 font-display text-lg md:text-xl text-ink-muted leading-relaxed">
                          {pickLocale(it.answer, locale)}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
